import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone, SimpleChanges } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Marker } from '../../../../interfaces/marker';
import { HasPermissionService } from '../../../employee/service/has-permission/has-permission.service';
import { Message, FileUpload } from 'primeng/primeng';
import { config } from '../../../../../environments/config';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { UploadFilesCandidateService } from '../../services/upload-files-candidate/upload-files-candidate.service';
import { ContactCandidateService } from '../../services/contact-candidate/contact-candidate.service';

@Component({
  selector: 'app-candidate-emergency-contact',
  templateUrl: './candidate-emergency-contact.component.html',
  styleUrls: ['./candidate-emergency-contact.component.scss']
})
export class CandidateEmergencyContactComponent implements OnInit, OnChanges {
  @Input() index: number;
  @Input() candidate_id: number;
  @Input() contact_candidate: any;
  @Output() contact_output: EventEmitter<any> = new EventEmitter<any>();
  @Output() add_contact_output: EventEmitter<any> = new EventEmitter<any>();

  public apiUrl = config.API_ROOT;
  public loading_upload: boolean = false;
  public promiseForm: Promise<any>;
  public msgs: Message[];
  
  public form: FormGroup;

  public relationshipOptions: any[];

  constructor(
    public fb: FormBuilder,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    public uploadFilesCandidateService: UploadFilesCandidateService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    public contactCandidateService: ContactCandidateService,
    private ngZone: NgZone
  ) {
    
    this.relationshipOptions = [
      { label: 'Madre', value: 'Madre' },
      { label: 'Padre', value: 'Padre' },
      { label: 'Hermano(a)', value: 'Hermano(a)' },
      { label: 'Hijo(a)', value: 'Hijo(a)' },
      { label: 'Esposo(a)', value: 'Esposo(a)' },
      { label: 'Primo(a)', value: 'Primo(a)' },
      { label: 'Sobrino(a)', value: 'Sobrino(a)' },
      { label: 'Tío(a)', value: 'Tío(a)' },
      { label: 'Abuelo(a)', value: 'Abuelo(a)' },
      { label: 'Nieto(a)', value: 'Nieto(a)' },
    ];
  }

  createForm(data:any=null){
    data = data || {
      id : null,
      name : null,
      relationship: null,
      phone: null,
    };  
    this.form = this.fb.group({
      id: new FormControl(data.id),
      name : new FormControl(data.name, Validators.compose([ Validators.minLength(3), Validators.required ])),
      relationship : new FormControl(data.relationship, Validators.compose([ Validators.minLength(1), Validators.required ])),
      phone : new FormControl(data.phone, Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.required, Validators.pattern('^[0-9]*$') ])),
    });
  }

  ngOnInit() {
    this.createForm(this.contact_candidate);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.editValues();
  }

  public addEmergencyContact(values) {
    this.loading_upload = true;
    values['index'] = this.index;
    values['candidate_id'] = this.candidate_id;
    values['in_case_of_emergency'] = 1;

    // const promise = this.contactCandidateService.add(values);

    const promise = (values.id) ? this.contactCandidateService.update(values.id, values) : this.contactCandidateService.add(values);
    this.promiseForm = promise.toPromise().then(
      response => {
        this.loading_upload = false;
        let resp_contact= response.json();
        resp_contact['index'] = this.index;
        this.add_contact_output.emit(resp_contact);
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
        });
      },
      error => {
        this.loading_upload = false;
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );

  }

  public deleteEmergencyContact(contact_candidate) {
    contact_candidate['index'] = this.index;
    this.contact_output.emit(contact_candidate);
    if(contact_candidate.id != undefined){
      const promise = this.contactCandidateService.delete(contact_candidate.id);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('deleted').subscribe((res: string) => {
            this.notificationsService.growlNotify('success', res);
          });
        },
        error => {
          let msg = '';
          this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
            this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
              JSON.parse(error._body).errors.forEach(element => {
                if (element.source) {
                  if (element.source.pointer) {
                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                      msg = msg + res3 + ', ';
                    });
                  }
                }
              });
              this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
            });
          });
        }
      );
    }
  }

  // public editValues() {
  //   if (this.contact_candidate != null && this.contact_candidate != undefined && this.contact_candidate != '') {
  //     this.name.setValue(this.contact_candidate.name);
  //     this.relationship.setValue(this.contact_candidate.relationship);
  //     this.phone.setValue(this.contact_candidate.phone);
  //   }
  // }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/components/candidate-emergency-contact/candidate-emergency-contact.component.ts